{
  "addSupplier": {
    "stepper": {
      "title": "Ajouter un fournisseur",
      "steps": {
        "generalInfo": {
          "title": "Informations générales",
          "description": "Saisir les informations générales du fournisseur"
        },
        "riskAssessment": {
          "title": "Évaluation des risques",
          "description": "Sélectionner le niveau de risque du fournisseur"
        },
        "supportingDocuments": {
          "title": "Documents justificatifs",
          "description": "Télécharger ou lier la documentation requise"
        },
        "approval": {
          "title": "Approbation",
          "description": "Vérifier toutes les informations et envoyer le fournisseur pour approbation"
        }
      },
      "buttons": {
        "saveAsDraft": "Enregistrer comme brouillon et quitter",
        "cancel": "Annuler",
        "previous": "Précédent",
        "next": "Suivant",
        "sendForApproval": "Envoyer pour approbation"
      }
    },
    "generalInfo": {
      "heading": "Informations générales",
      "fields": {
        "supplierName": {
          "label": "Nom du fournisseur*",
          "helper": "Ce champ est obligatoire lors de l'envoi pour approbation."
        },
        "supplierType": {
          "label": "Type de fournisseur",
          "helper": "Ce champ est obligatoire lors de l'envoi pour approbation."
        },
        "website": {
          "label": "Site web"
        },
        "intendedUse": {
          "label": "Utilisation prévue"
        },
        "sponsor": {
          "label": "Sponsor",
          "helper": "Ce champ est obligatoire lors de l'envoi pour approbation."
        }
      },
      "contactInfo": {
        "heading": "Coordonnées du fournisseur",
        "fields": {
          "name": "Nom",
          "email": "E-mail",
          "phone": "Téléphone",
          "address": "Adresse",
          "notes": "Notes"
        }
      },
      "warnings": {
        "invalidFields": "Certains champs semblent contenir des valeurs invalides."
      }
    },
    "riskAssessment": {
      "heading": "Évaluation des risques",
      "description": "Les niveaux de risque sont définis par la politique fournisseur. Si vous n'êtes pas sûr maintenant, vous pourrez y revenir plus tard. Notez que le niveau de risque est nécessaire pour attribuer les documents justificatifs requis par la politique."
    },
    "supportingDocuments": {
      "heading": "Documents justificatifs",
      "alerts": {
        "selectTypeAndRisk": "Sélectionnez le type de fournisseur et le niveau de risque pour voir quels documents sont requis.",
        "noMandatoryDocuments": "Votre politique fournisseur ne requiert aucun document obligatoire pour le type de fournisseur {{type}} et le niveau de risque {{level}}.",
        "documentsMovedTitle": "Documents déplacés vers « Documents supplémentaires »",
        "documentsMovedDescription": "Chaque niveau de risque peut nécessiter des documents différents. Comme le niveau de risque a été modifié, tous les documents ont été déplacés vers « Documents supplémentaires ». Pour les réutiliser, téléchargez-les et ajoutez-les aux documents requis. Ces changements prendront effet lorsque vous enregistrerez le fournisseur."
      },
      "policyText": "Votre politique fournisseur requiert les documents suivants pour le type de fournisseur {{type}} et le niveau de risque {{level}}.",
      "additionalDocumentsInfo": "Incluez toute documentation supplémentaire pertinente pour ce fournisseur."
    },
    "approval": {
      "heading": "Approbation",
      "infoText": "Vérifiez les informations du fournisseur avant de l'envoyer pour approbation.",
      "sections": {
        "generalInformation": "Informations générales",
        "supplierContactInformation": "Coordonnées du fournisseur",
        "riskLevel": "Niveau de risque",
        "supportingDocuments": "Documents justificatifs",
        "additionalDocuments": "Documents supplémentaires",
        "requiredAudits": "Audits requis",
        "approval": "Approbation"
      },
      "fields": {
        "supplierName": "Nom du fournisseur",
        "supplierType": "Type de fournisseur",
        "website": "Site web",
        "intendedUse": "Utilisation prévue",
        "sponsor": "Sponsor",
        "name": "Nom",
        "email": "E-mail",
        "phone": "Téléphone",
        "address": "Adresse",
        "notes": "Notes",
        "approvers": "Approbateurs"
      },
      "messages": {
        "noMandatoryDocuments": "Il n'y a pas de documents obligatoires",
        "noAdditionalDocuments": "Il n'y a pas de documents supplémentaires",
        "requiredAuditsPolicy": "Pour le type de fournisseur {{type}} et le niveau de risque {{level}}, votre politique fournisseur requiert ces audits",
        "noRequiredAuditsPolicy": "Pour le type de fournisseur {{type}} et le niveau de risque {{level}}, votre politique fournisseur ne requiert aucun audit obligatoire",
        "auditFrequency": "Tous les {{count}} mois",
        "auditOnce": "Une seule fois",
        "approvalInfo": "Sélectionnez les personnes pouvant approuver ce fournisseur. Au moins un utilisateur Qualité doit être sélectionné. Seuls les utilisateurs ayant accès aux fournisseurs peuvent être sélectionnés comme approbateurs. L'approbation sera accordée lorsque tous auront accepté.",
        "auditReviewWarning": "Si une révision des audits est nécessaire avant l'approbation, vous pouvez enregistrer ce fournisseur et ajouter l'audit ainsi que tous ses documents dans la section « Audits » de ce fournisseur."
      },
      "warnings": {
        "requiredFieldsMissing": "Certains champs obligatoires semblent manquants ou contiennent des valeurs invalides"
      },
      "supplierPolicyLink": "politique fournisseur"
    },
    "modals": {
      "discardChanges": {
        "title": "Abandonner les modifications",
        "message": "Êtes-vous sûr de vouloir abandonner vos modifications pour ce fournisseur ? Vous pouvez également l'enregistrer comme brouillon et terminer plus tard.",
        "buttons": {
          "cancel": "Annuler",
          "saveAsDraft": "Enregistrer comme brouillon",
          "discardChanges": "Abandonner les modifications"
        }
      },
      "cantSaveSupplier": {
        "title": "Impossible d'enregistrer le fournisseur",
        "message": "Pour enregistrer ce fournisseur, vous devez lui donner un nom.",
        "button": "Compris"
      },
      "changeSupplierType": {
        "title": "Modifier le type de fournisseur ?",
        "message": "Chaque niveau de risque peut nécessiter des documents différents. Tous les documents seront déplacés vers « Documents supplémentaires » lorsque vous enregistrerez le fournisseur.",
        "buttons": {
          "cancel": "Annuler",
          "change": "Modifier le type de fournisseur"
        }
      },
      "changeRiskLevel": {
        "title": "Modifier le niveau de risque ?",
        "message": "Chaque niveau de risque peut nécessiter des documents différents. Tous les documents seront déplacés vers « Documents supplémentaires » lorsque vous enregistrerez le fournisseur.",
        "buttons": {
          "cancel": "Annuler",
          "change": "Modifier le niveau de risque"
        }
      }
    },
    "validation": {
      "errors": {
        "supplierNameRequired": "Veuillez saisir un nom de fournisseur",
        "supplierNameEmpty": "Le nom du fournisseur ne peut pas être vide",
        "supplierNameTooLong": "Le nom du fournisseur ne peut pas dépasser 350 caractères",
        "supplierTypeRequired": "Veuillez sélectionner un type de fournisseur",
        "intendedUseTooLong": "Le champ Utilisation prévue ne peut pas dépasser 4000 caractères",
        "sponsorRequired": "Veuillez sélectionner un Sponsor",
        "contactNotesTooLong": "Le champ Notes de contact ne peut pas dépasser 4500 caractères",
        "riskTypeRequired": "Veuillez sélectionner un type de risque",
        "documentsRequired": "Au moins 1 document justificatif est requis pour : {{documentNames}}",
        "approversRequired": "Les approbateurs doivent être sélectionnés",
        "qualityUserRequired": "Les approbateurs doivent contenir au moins un utilisateur Qualité"
      },
      "fieldNames": {
        "name": "Nom",
        "approvers": "Approbateurs",
        "contactAddress": "Adresse de contact",
        "contactEmail": "E-mail de contact",
        "contactName": "Nom de contact",
        "contactNotes": "Notes de contact",
        "contactPhone": "Téléphone de contact",
        "documents": "Documents",
        "intendedUse": "Utilisation prévue",
        "riskType": "Type de risque",
        "sponsor": "Sponsor",
        "supplierType": "Type de fournisseur",
        "website": "Site web"
      }
    }
  },
  "supplierList": {
    "heading": "Fournisseurs",
    "buttons": {
      "addSupplier": "Ajouter un fournisseur",
      "import": "Importer",
      "exportAsl": "Exporter l'ASL",
      "exportCurrentView": "Exporter la vue actuelle en CSV",
      "exportFullView": "Exporter la vue complète en XLSX"
    },
    "search": {
      "placeholder": "Rechercher par nom"
    },
    "filters": {
      "selectSupplierType": "Sélectionner le type de fournisseur",
      "selectStatus": "Sélectionner le statut",
      "selectRiskType": "Sélectionner le type de risque",
      "showOnlyArchived": "Afficher uniquement les archivés"
    },
    "columns": {
      "name": "Nom",
      "type": "Type",
      "status": "Statut",
      "risk": "Risque",
      "sponsor": "Sponsor",
      "lastModified": "Dernière modification",
      "lastAudit": "Dernier audit",
      "dueIn": "Échéance dans"
    },
    "emptyState": {
      "title": "Vous n'avez pas encore de fournisseurs",
      "subtitle": "Avant d'ajouter un fournisseur, il est recommandé de créer une politique fournisseur. Celle-ci définira les types de fournisseurs avec lesquels vous travaillez, les niveaux de risque pour évaluer vos fournisseurs et les types de documents requis pour chaque fournisseur avant approbation.",
      "buttons": {
        "addSupplier": "Ajouter un fournisseur",
        "importSuppliers": "Importer des fournisseurs",
        "configurePolicy": "Configurer la politique"
      },
      "divider": "ou"
    },
    "errors": {
      "noApprovedSuppliers": "Aucun fournisseur approuvé à exporter",
      "cannotRetrievePolicyLinks": "Impossible de récupérer les liens de la politique"
    }
  },
  "supplierDetails": {
    "buttons": {
      "back": "Retour",
      "edit": "Modifier",
      "export": "Exporter",
      "archive": "Archiver",
      "unarchive": "Désarchiver",
      "revertToDraft": "Remettre en brouillon"
    },
    "tabs": {
      "details": "Détails",
      "supportingDocuments": "Documents justificatifs",
      "audits": "Audits"
    },
    "sections": {
      "riskLevel": "Niveau de risque",
      "generalInfo": "Informations générales",
      "supplierContactInformation": "Coordonnées du fournisseur"
    },
    "fields": {
      "supplierName": "Nom du fournisseur",
      "supplierType": "Type de fournisseur",
      "website": "Site web",
      "intendedUse": "Utilisation prévue",
      "sponsor": "Sponsor",
      "approvers": "Approbateurs",
      "createdOn": "Créé le",
      "lastModified": "Dernière modification",
      "name": "Nom",
      "email": "E-mail",
      "phone": "Téléphone",
      "address": "Adresse",
      "notes": "Notes",
      "contactName": "Nom",
      "contactEmail": "E-mail",
      "contactPhone": "Téléphone",
      "contactAddress": "Adresse",
      "contactNotes": "Notes"
    },
    "modals": {
      "archive": {
        "title": "Archiver",
        "message": "Êtes-vous sûr de vouloir archiver ce fournisseur ? Vous pouvez le désarchiver à tout moment.",
        "button": "Archiver"
      },
      "unarchive": {
        "title": "Désarchiver",
        "message": "Êtes-vous sûr de vouloir désarchiver ce fournisseur ? Son statut passera à « Brouillon ».",
        "button": "Désarchiver"
      },
      "revertToDraft": {
        "title": "Remettre en brouillon",
        "message": "Voulez-vous remettre ce fournisseur à l'état « Brouillon » ?",
        "button": "Rétablir"
      },
      "export": {
        "title": "Exporter le fournisseur",
        "message": "Le fournisseur sera exporté sous forme de fichier zip contenant :\n- Un fichier PDF avec tous les détails du fournisseur\n- Les documents justificatifs\n- Les fichiers d'audit",
        "button": "Exporter le fournisseur"
      }
    }
  },
  "supplierDocuments": {
    "emptyState": {
      "title": "Les documents pour ce fournisseur apparaîtront ici",
      "subtitle": "Si votre politique fournisseur requiert des documents spécifiques, modifiez le fournisseur pour les inclure ici."
    },
    "heading": "Documents supplémentaires"
  },
  "supplierAudits": {
    "columns": {
      "name": "Nom",
      "auditType": "Type d'audit",
      "notes": "Notes",
      "addedBy": "Ajouté par",
      "dateCompleted": "Date d'achèvement",
      "dateAdded": "Date d'ajout",
      "documents": "Documents",
      "filesCount": "{{count}} fichiers"
    },
    "menu": {
      "viewDocuments": "Voir les documents",
      "edit": "Edit",
      "delete": "Supprimer"
    },
    "emptyState": {
      "title": "Les audits terminés apparaîtront ici",
      "subtitle": "Enregistrez le résultat des audits précédents avec la date d'achèvement, les fichiers liés et des notes.",
      "button": "Ajouter un audit"
    },
    "buttons": {
      "addAudit": "Ajouter un audit"
    },
    "drawer": {
      "noDocuments": "Aucun document n'est disponible."
    },
    "modals": {
      "deleteAudit": {
        "title": "Supprimer l'audit",
        "message": "Êtes-vous sûr de vouloir supprimer cet audit ?",
        "buttons": {
          "cancel": "Annuler",
          "delete": "Supprimer l'audit"
        }
      },
      "addAudit": {
        "title": "Ajouter un audit",
        "buttons": {
          "cancel": "Annuler",
          "add": "Ajouter l'audit"
        }
      },
      "editAudit": {
        "title": "Edit audit",
        "buttons": {
          "cancel": "Annuler",
          "save": "Save audit"
        }
      }
    },
    "nextAudit": {
      "dueTemplate": "Le prochain audit {{auditType}} est dû dans {{interval}}",
      "overdueTemplate": "L'audit {{auditType}} est en retard de {{interval}}",
      "policyRequires": "La politique fournisseur requiert que ce fournisseur soit audité avec un audit {{auditType}} tous les {{frequency}} mois à compter de la date du dernier audit ({{lastAuditDate}})",
      "supplierPolicyLink": "politique fournisseur"
    }
  },
  "createAuditForm": {
    "heading": "Informations sur l'audit",
    "fields": {
      "auditName": {
        "label": "Nom de l'audit*",
        "error": "Veuillez remplir le nom de l'audit"
      },
      "auditType": {
        "label": "Type d'audit*",
        "error": "Veuillez remplir le type d'audit"
      },
      "notes": {
        "label": "Notes"
      },
      "completionDate": {
        "label": "Date d'achèvement",
        "helper": "La date d'achèvement détermine le prochain audit planifié de ce type selon la politique fournisseur.",
        "placeholder": "jj/mm/aaaa"
      }
    },
    "sections": {
      "auditDocuments": "Documents d'audit"
    },
    "errors": {
      "fillRequiredFields": "Veuillez remplir les champs obligatoires"
    }
  },
  "documentCard": {
    "buttons": {
      "addDocument": "Ajouter un document",
      "uploadFromComputer": "Télécharger depuis l'ordinateur",
      "qualioDoc": "Document Qualio",
      "download": "Télécharger",
      "open": "Ouvrir",
      "delete": "Supprimer",
      "addDescription": "Ajouter une description"
    }
  },
  "qualioDocSelect": {
    "noDocumentFound": "Aucun document trouvé avec le préfixe :",
    "placeholder": "Veuillez saisir un préfixe valide pour un document Qualio. Ex : « POL »"
  },
  "importModal": {
    "title": "Importer des fournisseurs",
    "description": "Si vous stockez les dossiers fournisseurs en tant que documents Qualio, vous pouvez les importer dans la liste des fournisseurs. Saisissez le préfixe du modèle des dossiers fournisseurs.",
    "fields": {
      "templatePrefix": {
        "label": "Préfixe du modèle",
        "helper": "Par exemple « SQF »",
        "button": "Rechercher"
      }
    },
    "messages": {
      "found": "{{count}} dossiers fournisseurs ont été trouvés avec le préfixe {{prefix}}",
      "notFound": "Aucun dossier fournisseur n'a été trouvé avec le préfixe {{prefix}}"
    },
    "buttons": {
      "cancel": "Annuler",
      "import": "Importer"
    }
  },
  "changeControlAlerts": {
    "approvalDeclined": "Approbation refusée",
    "approvalPreviouslyDeclined": "Approbation précédemment refusée",
    "declinedMessage": "{{name}} a refusé d'approuver ce fournisseur le {{date}} pour la raison suivante : « {{reason}} »"
  },
  "statusChangeModal": {
    "approveTitle": "Approuver le fournisseur",
    "rejectTitle": "Rejeter le fournisseur",
    "approveMessage": "Saisissez votre mot de passe pour approuver ce fournisseur.",
    "rejectMessage": "Saisissez votre mot de passe pour rejeter ce fournisseur.",
    "fields": {
      "email": {
        "label": "E-mail",
        "error": "Veuillez saisir un e-mail"
      },
      "password": {
        "label": "Mot de passe",
        "error": "Veuillez saisir un mot de passe"
      },
      "reason": {
        "label": "Motif du rejet",
        "error": "Veuillez saisir un motif pour rejeter ce fournisseur"
      }
    },
    "errors": {
      "fillRequiredFields": "Veuillez remplir les champs obligatoires",
      "somethingWentWrong": "Une erreur est survenue",
      "requiredFields": "Veuillez remplir les champs obligatoires",
      "generic": "Une erreur est survenue",
      "email": "Veuillez saisir un e-mail",
      "password": "Veuillez saisir un mot de passe",
      "reason": "Veuillez saisir un motif pour rejeter ce fournisseur"
    },
    "buttons": {
      "cancel": "Annuler",
      "approve": "Approuver",
      "reject": "Rejeter"
    }
  },
  "policyConfiguration": {
    "heading": "Configuration de la politique",
    "tabs": {
      "supplierTypes": "Types de fournisseurs",
      "riskLevels": "Niveaux de risque",
      "documentTypes": "Types de documents",
      "auditTypes": "Types d'audits"
    },
    "template": {
      "title": "Vous n'avez pas encore défini de types de révision",
      "subtitle": "Précisez quels types de révision seront utilisés dans la politique. Utilisez le modèle suggéré et modifiez-le selon vos besoins ou créez le vôtre.",
      "useTemplate": "Utiliser les définitions {{name}} suggérées",
      "buttons": {
        "useTemplate": "Utiliser ce modèle",
        "createFromScratch": "Créer de toutes pièces"
      },
      "divider": "ou"
    },
    "configurationCard": {
      "placeholders": {
        "name": "Nom",
        "addDescription": "Ajouter une description"
      }
    },
    "buttons": {
      "addNew": "Ajouter un nouveau",
      "cancel": "Annuler",
      "saveChanges": "Enregistrer les modifications"
    },
    "modals": {
      "saveChanges": {
        "title": "Enregistrer les modifications",
        "message": "Les modifications apportées aux types de fournisseurs affecteront tous les fournisseurs existants de ces types. Assurez-vous de revoir tous les fournisseurs concernés et de les réévaluer si nécessaire.",
        "buttons": {
          "cancel": "Annuler",
          "save": "Enregistrer les modifications"
        }
      }
    }
  },
  "supplierPolicy": {
    "heading": "Politique fournisseur",
    "buttons": {
      "configuration": "Configuration",
      "edit": "Modifier",
      "export": "Exporter"
    },
    "tabs": {
      "requiredDocuments": "Documents requis",
      "audits": "Audits"
    },
    "drawer": {
      "title": "Modifier la politique",
      "sections": {
        "supplierType": "Type de fournisseur",
        "riskLevel": "Niveau de risque",
        "requiredDocuments": "Documents requis",
        "audits": "Audits"
      },
      "descriptions": {
        "requiredDocuments": "La politique exigera l'ajout de ces documents pour qu'un fournisseur soit approuvé.",
        "audits": "Ces audits seront requis pour tous les fournisseurs de ce type et de ce niveau de risque."
      },
      "placeholders": {
        "addDocumentType": "Ajouter un type de document",
        "addAuditType": "Ajouter un type d'audit",
        "dueEvery": "Dû tous les"
      },
      "frequencyOptions": {
        "once": "Une fois",
        "monthsFromLastAudit": "{{count}} mois après le dernier audit"
      },
      "noTypesFound": "Les types {{type}} ne sont pas encore définis dans votre politique fournisseur ou vous avez sélectionné toutes les options disponibles.",
      "warning": "Les modifications apportées à la politique fournisseur affecteront tous les fournisseurs existants de ce type et de ce niveau de risque. Revoyez tous les fournisseurs concernés et réévaluez-les si nécessaire.",
      "buttons": {
        "cancel": "Annuler",
        "save": "Enregistrer"
      }
    },
    "table": {
      "supplierType": "TYPE DE FOURNISSEUR",
      "riskLevel": "NIVEAU DE RISQUE"
    }
  },
  "aslExport": {
    "coverPage": {
      "title": "Liste des fournisseurs approuvés (ASL)",
      "generatedBy": "Généré par {{userName}}",
      "generatedWith": "Généré avec",
      "qmsForLifeSciences": "QMS pour les Life Sciences",
      "website": "www.qualio.com"
    },
    "listPage": {
      "columns": {
        "supplierName": "Nom du fournisseur",
        "type": "Type",
        "riskLevel": "Niveau de risque",
        "intendedUse": "Utilisation prévue",
        "lastAudit": "Dernier audit",
        "auditDue": "Audit dû"
      }
    }
  },
  "upSellViews": {
    "upgradeAccess": {
      "title": "Passez au niveau supérieur pour accéder aux fournisseurs",
      "subtitle": "Votre forfait Qualio actuel n'inclut pas la nouvelle fonctionnalité Fournisseurs. Contactez votre responsable Customer Success pour savoir comment passer au forfait supérieur.",
      "button": "En savoir plus sur les Fournisseurs"
    },
    "insufficientPermissions": {
      "title": "Vous essayez de gérer votre chaîne d'approvisionnement ?",
      "subtitle": "Malheureusement, vous n'avez pas accès au module Fournisseurs pour le moment. Contactez votre administrateur pour intégrer, gérer et améliorer continuellement votre base de fournisseurs.",
      "button": "Voir la vidéo du produit"
    },
    "starterView": {
      "title": "Vous essayez de gérer votre chaîne d'approvisionnement ?",
      "subtitle": "Malheureusement, vous n'avez pas accès au module Fournisseurs pour le moment. Contactez notre équipe support pour intégrer, gérer et améliorer continuellement votre base de fournisseurs.",
      "buttons": {
        "contactSupport": "Contacter le support Qualio",
        "watchVideo": "Voir la vidéo du produit"
      }
    }
  },
  "emergencyBreak": {
    "title": "Le module Fournisseurs est en maintenance",
    "subtitle": "Nous effectuons actuellement des travaux de maintenance sur le module Fournisseurs. Prenez un café et revenez un peu plus tard. Contactez-nous si vous avez des questions."
  },
  "notFound": {
    "message": "Vous semblez être perdu"
  },
  "privateRoute": {
    "unauthorizedTitle": "Vous n'avez pas la permission d'accéder à ceci",
    "unauthorizedSubtitle": "Vous devez être connecté en tant qu'utilisateur Qualité pour voir et modifier les politiques fournisseurs. Si vous avez besoin d'un accès, contactez votre équipe qualité."
  },
  "navigation": {
    "tabs": {
      "supplier": "Fournisseur",
      "policy": "Politique"
    }
  },
  "statuses": {
    "approved": "Approuvé",
    "pending": "En attente",
    "rejected": "Rejeté",
    "draft": "Brouillon",
    "archived": "Archivé"
  },
  "toastMessages": {
    "supplier": {
      "archived": "Archivé",
      "archivedDescription": "{{name}} a été archivé",
      "archiveFailed": "Échec",
      "archiveFailedDescription": "Le fournisseur n'a pas été archivé",
      "failure": "Échec",
      "notArchived": "Le fournisseur n'a pas été archivé",
      "unArchived": "Désarchivé",
      "unArchivedDescription": "{{name}} a été désarchivé",
      "notUnArchived": "Le fournisseur n'a pas été désarchivé",
      "unarchived": "Désarchivé",
      "unarchivedDescription": "{{name}} a été désarchivé",
      "unarchiveFailed": "Échec",
      "unarchiveFailedDescription": "Le fournisseur n'a pas été désarchivé",
      "reverted": "Rétabli",
      "revertedDescription": "{{name}} a été remis en brouillon",
      "revertedToDraftDescription": "{{name}} a été remis en brouillon",
      "notRevertedToDraft": "Le fournisseur n'a pas été remis en brouillon",
      "revertFailed": "Échec",
      "revertFailedDescription": "Le fournisseur n'a pas été remis en brouillon",
      "saved": "Enregistré",
      "savedAsDraft": "{{name}} a été enregistré comme brouillon.",
      "savedAsDraftDescription": "{{name}} a été enregistré comme brouillon.",
      "notSavedAsDraft": "Le fournisseur n'a pas été enregistré comme brouillon",
      "notSentForApproval": "Le fournisseur n'a pas été envoyé pour approbation",
      "sent": "Envoyé",
      "sentForApproval": "{{name}} a été envoyé pour approbation",
      "sentForApprovalDescription": "{{name}} a été envoyé pour approbation",
      "saveFailed": "Échec",
      "saveFailedDescription": "Le fournisseur n'a pas été enregistré comme brouillon.",
      "fileReady": "Fichier prêt",
      "fileReadyDescription": "Le fichier est maintenant prêt à être",
      "download": "téléchargé",
      "exportFailed": "Échec",
      "exportFailedDescription": "Le fournisseur n'a pas été exporté",
      "notExported": "Le fournisseur n'a pas été exporté",
      "revertedToDraft": "{{name}} a été remis en brouillon",
      "revertToDraftFailed": "Le fournisseur n'a pas été remis en brouillon",
      "preparingFile": "Préparation du fichier pour le téléchargement",
      "preparingFileDescription": "Nous vous préviendrons dès que le fichier sera prêt",
      "exportsFailed": "Les fournisseurs n'ont pas été exportés",
      "suppliersNotExported": "Les fournisseurs n'ont pas été exportés"
    },
    "audit": {
      "added": "Audit ajouté",
      "creationFailed": "L'ajout de l'audit a échoué",
      "creationFailedDescription": "Impossible d'associer l'audit au fournisseur",
      "updated": "Audit updated",
      "updateFailed": "Audit update failed",
      "updateFailedDescription": "Failed to update the audit",
      "deleted": "Audit supprimé",
      "deletionFailed": "La suppression de l'audit a échoué",
      "deletionFailedDescription": "Impossible de supprimer l'audit du fournisseur"
    },
    "config": {
      "configuration": "Configuration",
      "updated": "{{configType}} a été mis à jour",
      "updateFailed": "La mise à jour de la configuration a échoué"
    },
    "policy": {
      "saved": "Politique enregistrée",
      "savedDescription": "Vous devrez peut-être réévaluer les fournisseurs concernés.",
      "saveFailed": "Échec",
      "saveFailedDescription": "Impossible d'enregistrer votre politique."
    },
    "policyLinks": {
      "fetchFailed": "Une erreur est survenue lors de la récupération de vos documents justificatifs requis"
    },
    "import": {
      "success": "Importation réussie",
      "successDescription": "Les fournisseurs ont été importés avec succès",
      "failed": "L'importation a échoué",
      "failedDescription": "Impossible d'importer les fournisseurs"
    },
    "approval": {
      "completed": "Action d'approbation terminée"
    },
    "document": {
      "downloadError": "Erreur",
      "downloadErrorDescription": "Une erreur est survenue lors du téléchargement de ce document"
    },
    "export": {
      "error": "Erreur",
      "errorDescription": "Aucun fournisseur approuvé à exporter",
      "policyLinksError": "Impossible de récupérer les liens de la politique",
      "supplierExportToast": "Export de {{name}}",
      "configExportToast": "Export de la configuration fournisseur"
    }
  },
  "common": {
    "buttons": {
      "cancel": "Annuler",
      "save": "Enregistrer",
      "delete": "Supprimer",
      "edit": "Modifier",
      "close": "Fermer",
      "review": "Réviser",
      "ok": "Ok",
      "gotIt": "Compris"
    },
    "placeholders": {
      "noData": "--"
    },
    "ariaLabels": {
      "deleteDescription": "supprimer-description",
      "downloadFile": "Télécharger le fichier",
      "openQualioDoc": "Ouvrir le document Qualio",
      "deleteFile": "Supprimer le fichier",
      "deletePolicyRow": "Supprimer la ligne de la politique",
      "viewRelatedRecords": "Voir les enregistrements liés"
    },
    "misc": {
      "auditType": "Type d'audit :",
      "name": "Nom :",
      "type": "Type :"
    }
  }
}
